import { ResendCodeError } from "../enums/resend-code-error.enum";

export const resendCodeErrorMappings = new Map<string, ResendCodeError>([
  ["LimitExceededException", ResendCodeError.TooManyCodeRequests],
]);